

import React, { useEffect, useState } from 'react';

const Providertsimagings = ({ diagnosisName, showDataIfNoteIsFollowUp = false, MasterDiagnosisData, contentEditable, imagingTypeList, imaging, noteStructureRef, showComment,loggedUserProvider,patientID,changesInTreatmentShell, setChangesInTreatmentShell }) => {
    const lastImaging = imaging && imaging.length > 0 ? imaging[imaging.length - 1] : null;

    const [matchingDiagnosisImaging, setMatchingDiagnosisImaging] = useState([]);

    useEffect(() => {
        if (imagingTypeList.length > 0 && MasterDiagnosisData && imaging.length > 0) {
            const matchedImagingList = [];

            imaging.forEach(singleImaging => {
                const impression = singleImaging?.data?.impression?.toLowerCase() || '';
                const selectedImagingName = singleImaging?.data?.name?.toLowerCase() || '';

                const matchedImagingMaster = imagingTypeList.find(item =>
                    item.Name.toLowerCase() === selectedImagingName
                );

                if (matchedImagingMaster) {
                    const matchedKeywords = matchedImagingMaster.Keywords.filter(keywordDetail => {
                        const keywordsArray = keywordDetail.keyword
                            .split(',')
                            .map(k => k.trim().toLowerCase())
                            .filter(k => k);
                        return keywordsArray.some(keyword => impression.includes(keyword));
                    });

                    matchedKeywords.forEach(remarkD => {
                        const masterD = MasterDiagnosisData.find(item => item.id === Number(remarkD.diagnosis));
                        if (masterD && diagnosisName.trim() === masterD.Name.trim()) {
                            matchedImagingList.push({
                                ...masterD,
                                ...remarkD,
                                ...singleImaging
                            });
                        }
                    });
                }
            });

            console.log(matchedImagingList, 'matchedImagingList')

            setMatchingDiagnosisImaging(matchedImagingList);

            if (noteStructureRef && noteStructureRef.current) {
                noteStructureRef.current = {
                    ...noteStructureRef.current,
                    imagingDetails: {
                        ...noteStructureRef.current.imagingDetails,
                        [diagnosisName]: matchedImagingList.length > 0 ? matchedImagingList : [],
                    },
                };
            }

            if (matchedImagingList.length === 0) {
                setMatchingDiagnosisImaging([]);
                if (noteStructureRef && noteStructureRef.current) {
                    noteStructureRef.current = {
                        ...noteStructureRef.current,
                        imagingDetails: {
                            ...noteStructureRef.current.imagingDetails,
                            [diagnosisName]: [],
                        },
                    };
                }
            }
        }
    }, [imagingTypeList, imaging, diagnosisName, MasterDiagnosisData, noteStructureRef]);

    useEffect(() => {
        if (diagnosisName === "Cognitive Communication Deficit") {
            console.log(matchingDiagnosisImaging, 'matchingDiagnosisImagingList', diagnosisName)
        }
    }, [])

    return (
        // <div>
        //     <div>
        //         {/* {matchingDiagnosisImaging && matchingDiagnosisImaging.data && (
        //             <>
        //                 <p className='text-warning'>{new Date(matchingDiagnosisImaging.date).toLocaleDateString('en-US')} : {matchingDiagnosisImaging.data.name}</p>
        //                 <p className='text-warning' >{matchingDiagnosisImaging.data.impression}</p>
        //                 {showComment && <p className='text-warning' >{matchingDiagnosisImaging.data?.comment}</p>}
        //             </>
        //         )
        //             :
        //                 <p>No Data</p>
        //         } */}
        //         <div>
        //             {matchingDiagnosisImaging?.data ? (
        //                 <>
        //                     <p className="text-warning">
        //                         {new Date(matchingDiagnosisImaging.date).toLocaleDateString('en-US')} :{" "}
        //                         {matchingDiagnosisImaging.data.name}
        //                     </p>
        //                     <p className="text-warning">{matchingDiagnosisImaging.data.impression}</p>
        //                     {showComment && (
        //                         <p className="text-warning">{matchingDiagnosisImaging.data.comment}</p>
        //                     )}
        //                 </>
        //             ) : (
        //                 <p></p>
        //             )}
        //         </div>

        //     </div>
        // </div>
        <div>
            <div>
                {Array.isArray(matchingDiagnosisImaging) && matchingDiagnosisImaging.length > 0 ? (
                    matchingDiagnosisImaging
                        .sort((a, b) => {
                            const priorityA = Number(a.data?.priority ?? 0);
                            const priorityB = Number(b.data?.priority ?? 0);

                            if (priorityA !== priorityB) {
                                return priorityA - priorityB;
                            }

                            return new Date(b.date) - new Date(a.date);
                        })
                        .map((item, index) => (
                            <div key={index} className="mb-3">
                                <p className="text-warning p-0 mb-1 m-0">
                                    {new Date(item.date).toLocaleDateString('en-US')} : {item.data.name}
                                </p>
                                <p style={{whiteSpace:"pre-wrap"}} className="text-warning">{item.data.impression}</p>
                                {showComment && (
                                    <p className="text-warning">{item.data.comment}</p>
                                )}
                            </div>
                        ))
                ) : (
                    <div className="d-flex justify-content-start align-items-start text-muted">
            <div
              style={{
                fontSize: '15px',
                fontWeight: '600px',
                color: 'gray',
              }}
            >
              No Imaging Exist
            </div>
          </div>
                )}
            </div>
        </div>

    );
};

export default Providertsimagings;
